import './index.sass';

import React from 'react';
import ReactDOM from 'react-dom/client';
import {HashRouter,Routes,Route} from "react-router-dom";

import Main from './pages/main';
import Tickers from './pages/tickers';
import Sandbox1 from './pages/sandbox-1';
import Sandbox2 from './pages/sandbox-2';
import Sandbox3 from './pages/sandbox-3';
import Sandbox4 from './pages/sandbox-4';
import Sandbox5 from './pages/sandbox-5';
import Sandbox6 from './pages/sandbox-6';
import Sandbox7 from './pages/sandbox-7';
import Sandbox8 from './pages/sandbox-8';
import Sandbox9 from './pages/sandbox-9';


function main() {
    const root = ReactDOM.createRoot(document.getElementById('root'));



    function App() {
        return (
            <HashRouter>
                <Routes>
                    <Route path="/" element={<Main />} />
                    <Route path="tickers" element={<Tickers />} />
                    <Route path="sandbox-1" element={<Sandbox1 />} />
                    <Route path="sandbox-2" element={<Sandbox2 />} />
                    <Route path="sandbox-3" element={<Sandbox3 />} />
                    <Route path="sandbox-4" element={<Sandbox4 />} />
                    <Route path="sandbox-5" element={<Sandbox5/>} />
                    <Route path="sandbox-6" element={<Sandbox6/>} />
                    <Route path="sandbox-7" element={<Sandbox7/>} />
                    <Route path="sandbox-8" element={<Sandbox8/>} />
                    <Route path="sandbox-9" element={<Sandbox9/>} />
                </Routes>
            </HashRouter>

        );
    }

    root.render(
        <App />

    );
    /*
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
    */
    
}

main();
